import * as Croppie from "croppie";
import './CroppieWrapper.scss';
import {CroppieOptionsServiceName} from "../../../utils/names/serviceNames";
import {CroppieOptionsService} from "../../service/CroppieOptionsService";

export const CroppieWrapper = ({
    bindings: {
        src: '<',
        ngModel: '='
    },
    controller: ['$scope', '$element', CroppieOptionsServiceName, function ($scope, $element, croppieService: CroppieOptionsService) {
        var ctrl = this;

        croppieService.subscribeForOptions((options) => {
            this.options = options;
        });

        this.$onInit = function () {
            let passedOption = this.options ? this.options : {};
            var options: any = Object.assign(
                {
                    update: function () {
                        // @ts-ignore
                        c.result('canvas').then(function (img) {
                            $scope.$apply(function () {
                                ctrl.ngModel(c.get());
                            });
                        });
                    }
                },
                passedOption
            );
            var c = new Croppie($element[0], options);

            c.bind({
                url: this.src
            });

            ctrl.$onChanges = function (changesObj) {
                var src = changesObj.src && changesObj.src.currentValue;
                if (src) {
                    // bind an image to croppie
                    c.bind({
                        url: src
                    });
                }
            };
        };
    }]
});
